import React from 'react';
import styled from 'styled-components';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import SearchPage from './pages/SearchPage';
import ChatPage from './pages/ChatPage';
import ProjectsPage from './pages/ProjectsPage';
import UpgradePage from './pages/UpgradePage';
import Play from './pages/Play';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { AuthProvider, useAuth } from './context/AuthContext';
import NotificationProvider from './context/NotificationContext';
import Notification from './components/Notification';

// Protected Route component
const ProtectedRoute = ({ children, allowGuest = false }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // If still loading auth state, show nothing (or a loading spinner)
  if (loading) {
    return <div>Loading...</div>;
  }

  // If not authenticated but guest access is allowed (like for chat), proceed anyway
  if (!currentUser && allowGuest) {
    console.log('Guest access allowed for this route');
    return children;
  }

  // If not authenticated and guest access not allowed, redirect to home
  if (!currentUser) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // If authenticated, render the requested page
  return children;
};

// Main App component with routing
const AppRoutes = () => {
  return (
    <>
      <Notification />
      <Routes>
        <Route path="/" element={<SearchPage />} />
        <Route path="/search" element={<Navigate to="/" replace />} />
        <Route 
          path="/chat" 
          element={
            <ProtectedRoute allowGuest>
              <ChatPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/projects" 
          element={
            <ProtectedRoute>
              <ProjectsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/upgrade" 
          element={
            <ProtectedRoute>
              <UpgradePage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/play/:fileId" 
          element={<Play />} 
        />
        <Route path="/terms" element={<TermsOfService />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
    </>
  );
};

// Wrap the app with AuthProvider and NotificationProvider
const App = () => {
  return (
    <AuthProvider>
      <NotificationProvider>
        <AppRoutes />
      </NotificationProvider>
    </AuthProvider>
  );
};

export default App;
